export const PAGE_WITHOUT_CTA = Object.freeze(["/contact", "/contact/"])
